import { Load } from "./Load";
import { ExtraType } from "./ExtraType";
import { BookDirectOrder } from "../../features/bookDirect/model/BookDirectOrder";
import moment from "moment";
import { AddressState } from "./AddressState";
import { momentFromDateStringAndHour } from "../formatters";

export class QuoteRequestShipment {
  startAddress:
    | string
    | { street: string; houseNumber: string; zipCode: string; city: string };
  endAddress:
    | string
    | { street: string; houseNumber: string; zipCode: string; city: string };
  startTimeFrom: moment.Moment;
  startTimeTo: moment.Moment;
  endTimeFrom: moment.Moment;
  endTimeTo: moment.Moment;
  loads: Load[];
  extras: ExtraType[];

  constructor(
    startAddressState: AddressState,
    endAddressState: AddressState,
    date: string,
    startWindow: [number, number],
    endWindow: [number, number],
    loads: Load[],
    extras: ExtraType[]
  ) {
    this.startAddress = addressRequestForAddressState(startAddressState);
    this.endAddress = addressRequestForAddressState(endAddressState);
    this.startTimeFrom = momentFromDateStringAndHour(date, startWindow[0]);
    this.startTimeTo = momentFromDateStringAndHour(date, startWindow[1]);
    this.endTimeFrom = momentFromDateStringAndHour(date, endWindow[0]);
    this.endTimeTo = momentFromDateStringAndHour(date, endWindow[1]);
    this.loads = loads;
    this.extras = extras;
  }

  static shipmentForDirectOrder = (
    order: BookDirectOrder
  ): QuoteRequestShipment => {
    if (!order.date) throw new Error("validation failed: date missing");
    return new QuoteRequestShipment(
      order.startAddress,
      order.endAddress,
      order.date,
      order.startWindow,
      order.endWindow,
      order.loads,
      order.extras
    );
  };
}

const addressRequestForAddressState = (
  state: AddressState
):
  | string
  | { street: string; houseNumber: string; zipCode: string; city: string } => {
  if (state.create)
    return {
      street: state.create.street!,
      houseNumber: state.create.houseNumber!,
      zipCode: state.create.zipCode!,
      city: state.create.validatedZip!.city
    };
  return state.id!;
};
